<template>
  <div :class="{ 'c-mypageProfileSp': isMypageSp }">
    <div class="c-mypageProfile">
      <div class="c-mypageProfile_user">
        <div class="c-mypageProfile_icon">
          <component
            :is="!isBusiness ? 'NuxtLink' : 'div'"
            :to="!isBusiness ? '/mypage/user' : ''"
          >
            <div>
              <c-user-icon-v2
                :file-path="auth.user.resizableProfileIcon"
                :user-name="auth.user.name"
                :size="isMypageSp ? 62 : 128"
                :width="256"
                :height="256"
              />
            </div>
          </component>
        </div>
        <div class="c-mypageProfile_profile">
          <div class="c-mypageProfile_name">
            <span>{{ auth.user.name }}</span>
          </div>
          <div
            v-if="!isBusiness"
            class="c-mypageProfile_edit"
          >
            <NuxtLink to="/mypage/user">
              <span class="c-mypageProfile_sidebarEdit">プロフィール編集
                <coconala-icon name="pencil-square-o" />
              </span>
            </NuxtLink>
          </div>
        </div>
      </div>
      <div
        v-if="!isBusiness"
        class="c-mypageProfile_schedule"
      >
        <a
          class="c-mypageProfile_scheduleEdit"
          :href="$coconala.url('/mypage/user/info')"
        >
          スケジュール編集
          <coconala-icon name="pencil-square-o" />
        </a>
      </div>
    </div>
    <div
      class="c-dashboardProviderRank-pc"
      v-if="(isProvider || (isBlogger && hasFetchedBlogger)) && !isMypageSp && !isBusiness"
    >
      <a
        href="/pages/about_rank"
        class="c-dashboardProviderRankPc"
      >
        <div class="c-dashboardProviderRankPc_rank">
          <div class="c-dashboardProviderRankPc_icon">
            <img
              :src="$coconala.levelIconURL(level.value, true)"
              alt=""
              class="c-levelIcon_level"
            >
          </div>
          <div class="c-dashboardProviderRankPc_name">
            <span v-if="level.value">{{ level.nameText }}ランク</span>
            <span v-else>ランクなし</span>
          </div>
        </div>
        <div class="c-dashboardProviderRankPc_help">
          <span v-if="level.value === levelMax">出品者ランクを維持するには</span>
          <span v-else>出品者ランクを上げるには</span>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
const LEVEL_PT = 5

import { mapState } from 'vuex'

export default {
  name: 'MypageProfile',
  props: {
    auth: {
      type: Object
    },
    isMypageSp: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('auth/user', ['level', 'isProvider', 'isBusiness']),
    ...mapState('my/header', ['isBlogger', 'hasFetchedBlogger']),
    levelMax() {
      return LEVEL_PT
    }
  }
}
</script>

<style lang="scss" scoped>
.c-mypageProfile {
  text-align: center;

  a {
    display: inline-block;

    &:hover {
      opacity: 0.5;
    }
  }

  &_schedule {
    margin-top: 4px;
  }

  &_icon {
    min-height: 128px;
    .c-userIcon {
      border: 1px solid $color-gray-200;
    }
  }

  &_name {
    margin-top: 8px;
    color: $color-gray-900;
    font-size: 18px;
  }

  &_edit {
    margin-top: 8px;
  }

  &_sidebarEdit {
    font-size: 12px;
  }

  &_scheduleEdit {
    font-size: 12px;
  }

  &_scheduleNew {
    color: $color-pink-500;
    font-size: 11px;
  }

  .-pencil-square-o {
    padding-left: 4px;
    vertical-align: -1px;
  }
}

.c-mypageProfileSp {
  .c-mypageProfile {
    &_user {
      display: flex;
      margin-top: 0;
    }

    &_icon {
      margin-right: 8px;
      min-height: auto;
    }

    &_name {
      margin-top: 0;
      text-align: left;
      font-size: 14px;
    }

    &_profile {
      flex: 1;
    }

    &_sidebarEdit {
      font-size: 12px;
    }

    &_edit {
      margin-top: 0;
      text-align: right;

      a {
        display: block;
        line-height: 32px;
      }
    }

    &_schedule {
      margin-top: 0;
      text-align: right;

      a {
        display: block;
        line-height: 32px;
      }
    }
  }
}

.c-dashboardProviderRank {
  &-pc {
    margin-top: 20px;
    text-align: center;
  }
}

.c-dashboardProviderRankPc {
  @include link-effect;

  display: inline-block;

  &_rank {
    display: flex;

    align-items: center;
    justify-content: center;
  }

  &_help {
    margin-top: 8px;
    text-align: center;
    font-size: 12px;
    line-height: 100%;
  }

  &_icon {
    margin-right: 8px;
    width: 32px;
  }

  &_name {
    color: $color-gray-900;
    font-weight: bold;
    font-size: 16px;
    line-height: 100%;
  }
}

@media (max-width: breakpoint(Default, M)) {
  .c-mypageProfile {
    &_icon {
      min-height: 62px;
    }
  }

  .c-dashboardProviderRank {
    &-pc {
      display: none;
    }
  }
}
</style>
